import { useLayoutEffect, useState } from 'react'
import ScrollAnimation from './ScrollAnimation'
import GradientText from './GradienText'
import { capacityTab, doContent, CONTACT_US } from '../config'
import institSvg from '@/assets/images/home/institution.svg'
import message from '@/assets/images/home/message.svg'
import circleChevronRight from '@/assets/images/home/circle-chevron-right.svg'
import AutoScroll from '@/components/AutoScroll'
import AutoSwitch from './AutoSwitch'
import homeBg1 from '@/assets/images/home/home_bg1.png'
import homeBg2 from '@/assets/images/home/home_bg2.png'
import homeBg3 from '@/assets/images/home/home_bg3.png'
import homeBg4 from '@/assets/images/home/home_bg4.png'

const Home = () => {
  const [hoverItem, setHoverItem] = useState('')

  const handleCapacity = () => {
    return capacityTab.map((capacity, index) => {
      return {
        id: capacity.key,
        title: (
          <div className="text-white h-12 w-[120px] sm:w-[140px] lg:h-[48px] h-[36px] flex-1 flex justify-center items-center cursor-pointer lg:text-[16px] text-[14px]">
            {capacity.label}
          </div>
        ),
        content: (
          <div className="w-full h-full flex flex-wrap justify-center gap-8">
            {capacity.children.map(item => {
              return (
                <div
                  key={item.key}
                  className="cursor-pointer transition-colors duration-2000 ease relative mt-7 min-w-[250px] max-w-[350px] bg-gradient-to-b from-[#8874b940] to-[#2c1e4e40] hover:bg-gradient-to-b hover:from-[#8b62c4] hover:to-[#10059b] h-[300px] p-4  pt-1  lg:p-5 lg:pt-0 flex flex-col items-center text-white"
                >
                  <div className="absolute top-[-25%] lg:w-[50%] w-[40%]">
                    <img src={item.img} alt="" />
                  </div>
                  <div className="text-[25px] flex-center mt-[100px] lg:text-[28px] font-bold mb-2 lg:mb-6 ">
                    {item.title}
                  </div>
                  <div className="px-6 flex-center text-[12px]  text-[rgba(255,255,255,0.85)] leading-6">
                    {item.describe}
                  </div>
                </div>
              )
            })}
          </div>
        ),
        className: 'border-0',
        activeClassName: 'rounded-full bg-[#2d2e51]',
      }
    })
  }

  useLayoutEffect(() => {
    // 滚动页面到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="bg-overlay-dark w-full h-full">
      {/* 第一部分 */}
      <div
        className="bg-overlay-dark flex-center bg-cover"
        style={{
          backgroundImage: `url(${homeBg1})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="max-w-[1200px] h-[100vh] min-h-[509px] px-10 mx-auto flex flex-col justify-center items-center">
          <ScrollAnimation>
            <GradientText
              colors={['#e6d2ff', '#b77eff', '#913bfe', '#7c43fe', '#b4a2fe']}
              animationSpeed={3}
              showBorder={false}
              className="text-[30px] md:text-[50px] lg:text-[66px]"
            >
              紫东太初大模型
            </GradientText>
          </ScrollAnimation>
          <ScrollAnimation>
            <div className="flex-center text-[16px] lg:text-[32px] text-white mt-[30px]">
              新一代多模态大模型
            </div>
          </ScrollAnimation>
          <div>
            <div className="flex gap-6 text-[12px] text-white mt-[15px]">
              <div className="px-[10px] py-[5px] text-[#99a0ff] flex-center gap-2 border rounded-full border-[#ffffff20]">
                <img src={institSvg} />
                中国科学院自动化研究所
              </div>
              <div className="px-[10px] py-[5px] text-[#99a0ff] flex-center gap-2 border rounded-full border-[#ffffff20]">
                <img src={institSvg} />
                武汉人工智能研究院
              </div>
            </div>
          </div>
          <ScrollAnimation>
            <div className="mt-[30px] text-[14px] max-w-[624px] xl:max-w-[826px] text-white text-center">
              支持多轮问答、文本创作、图像生成、3D理解、信号分析等全面问答任务，拥有更强的认知、理解、
              创作能力，带来全新互动体验。
            </div>
          </ScrollAnimation>
          <div
            onClick={() => window.open('/#/chat', '_blank')}
            className="mt-[40px] cursor-pointer px-[20px] py-[5px] text-[18px] lg:px-[30px] lg:py-[10px] hover:text-white text-white rounded-full flex-center gap-3 hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]"
          >
            <img src={message} />
            立即对话
          </div>
        </div>
      </div>
      {/* 第二部分 */}
      <div
        className="bg-overlay-dark flex-center bg-cover"
        style={{
          backgroundImage: `url(${homeBg2})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="lg:h-[100vh] px-10 min-h-[1200px] mx-auto flex flex-col justify-center items-center">
          <ScrollAnimation>
            <div
              style={{ fontWeight: '900', letterSpacing: '4px' }}
              className="text-[30px] md:text-[45px] mt-[50px] lg:text-[60px] text-white lg:h-[60px]"
            >
              深度优化 显著领先
            </div>
          </ScrollAnimation>
          <ScrollAnimation>
            <AutoSwitch
              items={handleCapacity()}
              interval={2000}
              startActiveIndex={0}
              wrapperClassName="mt-[40px] flex flex-col w-full h-full flex-center"
              titleWrapperClassName="w-auto mb-[80px] flex items-center justify-between rounded-full bg-[#2d2e5160] mt-[20px] mb-10 p-[3px]"
            />
          </ScrollAnimation>
        </div>
      </div>

      {/* 第三部分 */}
      <div
        className="bg-overlay-dark flex-center bg-cover"
        style={{
          backgroundImage: `url(${homeBg3})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className=" max-w-[1200px] h-auto lg:h-[calc(100vh-80px)] lg:min-h-[900px] min-h-[509px] mx-auto flex flex-col justify-center items-center">
          <ScrollAnimation>
            <div
              style={{ fontWeight: '900', letterSpacing: '4px' }}
              className="flex-center text-[30px] md:text-[45px] lg:text-[60px] text-white lg:h-24"
            >
              紫东太初可以做什么
            </div>
          </ScrollAnimation>
          <ScrollAnimation>
            <div className="w-[90vw] max-w-[850px] mt-[20px] mb-[80px] mx-auto text-center text-[14px] lg:text-[16px] text-[#EBEBFF]">
              紫东太初可以理解三维场景、信号等数字物联时代的重要信息，完成了音乐、图片和视频等数据之间的跨模态对齐，能够处理音乐视频分析、三维导航等多模态关联应用需求，并可实现音乐、视频等多模态内容理解和生成
            </div>
          </ScrollAnimation>
          <div className="w-full">
            <ScrollAnimation>
              <AutoScroll speed={1.5}>
                {doContent.map((item: any) => (
                  <div
                    key={item.title}
                    onMouseEnter={() => {
                      setHoverItem(item.title)
                    }}
                    onMouseLeave={() => {
                      setHoverItem('')
                    }}
                    className={
                      'hover:bg-gradient-to-b hover:from-[#33324d] hover:to-[#36194d] cursor-pointer flex-shrink-0 px-[15px] w-[300px] h-[200px] border-l-[1px] border-solid border-white/[0.1] hover:border-white bg-[rgba(44,30,78,0.4)]'
                    }
                  >
                    <div className="w-full h-full flex flex-col justify-center items-start gap-5 ">
                      <img
                        className="w-[40px] h-[40px]"
                        src={item.img}
                        alt=""
                      />
                      <div>
                        <div
                          className={`${hoverItem === item.title ? 'bg-gradient-to-r from-[#dcc1ff] via-[#7b42fe] to-[#b3a0ff] bg-clip-text text-transparent' : ' text-white'} h-[30px] text-base font-bold mb-2 lg:mb-4 lg:text-[22px] text-left w-full`}
                        >
                          {item.title}
                        </div>
                        <div className="text-[12px] h-[50px] whitespace-normal text-[rgba(255,255,255,0.85)]">
                          {item.describe}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </AutoScroll>
            </ScrollAnimation>
          </div>
        </div>
      </div>

      {/* 第四部分 */}
      <div
        className="bg-overlay-dark bg-cover flex-center"
        style={{
          backgroundImage: `url(${homeBg4})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className=" max-w-[1200px] h-[514px] flex-1 py-10 mx-auto flex flex-col justify-center items-center">
          <ScrollAnimation>
            <div
              style={{ fontWeight: '700', letterSpacing: '4px' }}
              className="text-[25px] md:text-[30px] lg:text-[36px] text-white lg:max-w-[800px] xl:max-w-[1200px] break-words"
            >
              紫东太初4.0开启多模态智能体时代
            </div>
          </ScrollAnimation>
          <ScrollAnimation>
            <div className="mt-[20px] mb-[20px] w-full text-center text-[20px] lg:text-[24px] max-w-[624px] text-white tracking-wide flex-1">
              紫气东来 混沌初开
            </div>
          </ScrollAnimation>
          <a
            href={CONTACT_US}
            target="_blank"
            className="mt-[40px] cursor-pointer px-[20px] py-[5px] text-[18px] lg:px-[30px] lg:py-[10px] hover:text-white text-white rounded-full flex-center gap-3 hover:bg-gradient-to-r hover:from-[#86abff] hover:to-[#d1a2ff] bg-gradient-to-r from-[#1854f8] to-[#b678fe]"
            rel="noreferrer"
          >
            联系我们
            <img src={circleChevronRight} />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Home
